import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as NavConstants from 'constants/NavConstants';
import {Filter, FilterKey, keyToEmptyFilter, MultiValueFilter} from 'search/SearchConstants';
import {getAppliedFiltersFromUserPreference} from 'search/SearchPreferences';

import includeAnalysesInSearch from './includeAnalysesInSearch';

function findTypesFilter(
  filters: Array<Filter>
): {filter: MultiValueFilter; index: number} | {filter: null; index: null} {
  const index = filters.findIndex((filter) => filter.key === FilterKey.TYPES);
  if (index < 0) {
    return {filter: null, index: null};
  } else {
    return {filter: filters[index] as MultiValueFilter, index};
  }
}

function getDefaultTypeFilter(): Filter {
  return {
    ...keyToEmptyFilter(FilterKey.TYPES),
    value: includeAnalysesInSearch()
      ? [ModelTypeConstants.ANALYTICS_DASHBOARD, ModelTypeConstants.ANALYSIS]
      : [ModelTypeConstants.ANALYTICS_DASHBOARD],
  };
}

function removeInvalidFilters(filters: Array<Filter>): Array<Filter> {
  const newFilters = [...filters];
  if (!includeAnalysesInSearch()) {
    const {filter, index} = findTypesFilter(filters);
    if (index != null && filter?.value.includes(ModelTypeConstants.ANALYSIS)) {
      newFilters.splice(index, 1);
    }
  }
  return newFilters;
}

function addDefaultFilters(filters: Array<Filter>): Array<Filter> {
  const newFilters = [...filters];
  if (!findTypesFilter(filters).filter) {
    newFilters.push(getDefaultTypeFilter());
  }
  return newFilters;
}

export default function getDefaultAnalyticsSearchFilters(): Array<Filter> {
  let filters = getAppliedFiltersFromUserPreference(NavConstants.Section.ANALYTICS);
  filters = removeInvalidFilters(filters);
  filters = addDefaultFilters(filters);
  return filters;
}
